import { getUserData } from '@/auth/utils'

export default [
  {
    title: 'All',
    icon: 'Homeicon',
    route: { name: 'home' },
    Permission: 'Public',
    position: 'top',
  },
  {
    title: 'AI Co-Teacher',
    icon: 'MessageCircleIcon',
    route: { name: 'chatbot' },
    Permission: 'Access Chatbot',
    position: 'down',
  },
  {
    title: 'Users',
    icon: 'UsersIcon',
    route: { name: 'users' },
    Permission: 'Access User',
    position: 'down',
  },

  {
    title: 'Categories',
    icon: 'GridIcon',
    route: { name: 'categories' },
    Permission: 'Access category',
    position: 'down',
  },
  {
    title: 'Experiments',
    icon: 'ActivityIcon',
    route: { name: 'experiments' },
    Permission: 'Access Experiment',
    position: 'down',
  },
  {
    title: 'Versions',
    icon: 'LayersIcon',
    route: { name: 'versions' },
    Permission: 'Access Version',
    position: 'down',
  },
  {
    title: 'Institutions',
    icon: 'BookmarkIcon',
    route: { name: 'institutions' },
    Permission: 'Access Institution',
    position: 'down',
  },
  {
    title: 'My Institution',
    icon: 'UserIcon',
    route: { name: 'institution_profile' },
    Permission: 'Access My Institution',
    position: 'down',
  },
  {
    title: 'Logs',
    icon: 'FileIcon',
    route: { name: 'logs' },
    Permission: 'Access Logs',
    position: 'down',
  },
  {
    title: 'Roles',
    icon: 'SettingsIcon',
    route: { name: 'roles' },
    Permission: 'Access Role',
    position: 'down',
  },
  {
    title: 'Institution Dashboard',
    icon: 'MonitorIcon',
    route: { name: 'institution_dashboard' },
    Permission: 'Access Institution Dashboard',
    position: 'down',
  },
  {
    title: 'Admin Dashboard',
    icon: 'LayoutIcon',
    route: { name: 'admin_institution_dashboard' },
    Permission: 'Access Admin Dashboard',
    position: 'down',
  },
  {
    title: 'My Profile',
    icon: 'UserIcon',
    route: { name: 'pages_profile' },
    Permission: 'Public',
    position: 'down',
  },
  {
    title: 'Login',
    icon: 'LogInIcon',
    route: { name: 'auth-login' },
    Permission: 'logIn',
    position: 'down',
  },
  {
    title: 'Logout',
    icon: 'LogOutIcon',
    route: { name: 'logout' },
    Permission: 'logOut',
    position: 'down',
  },
]
